import React, { Component } from "react";
import { Card, CardBody, Col, Button, Label, FormGroup, Alert } from "reactstrap";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class TestimonyReportEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            id: 0,
            week: 1,
            victimId: this.props.victimId,
            weeks: [],
            success: false
        };
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.saveTask = this.saveTask.bind(this);
        this.emptyTemplate = this.emptyTemplate.bind(this);
        this.getWeekNumber = this.getWeekNumber.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        const options = [];
        const categories = [];

        this.getWeekNumber();

        let formFieldData = fetch(process.env.REACT_APP_API + 'victim/narrative/'+ this.props.victimId, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', "Authorization": accessToken },
		}).then(res => res.json());

		Promise.all([formFieldData])
			.then(([data]) => { 
                this.setState({  
                    editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(data.content))),
                    week: data.week,
                    id: data.id,
                    success: true
                  }); 
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: err,
				});
			});
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    getWeekNumber() {
        const currentDate = new Date();
        const startDate = new Date(currentDate.getFullYear(), 0, 1);
        const days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));

        const weekNumber = Math.ceil(days / 7);
        this.setState({
            week: weekNumber
        });
    }

    emptyTemplate(event){
        event.preventDefault();

        this.setState({
            success: false
        });

        const defaultContent = {"blocks":[{"key":"utjd","text":"Abstract","type":"header-four","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"margin-left":"0px"}},{"key":"c6tns","text":"Please give abstract info about the person","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3f9d4","text":"Notes","type":"header-four","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"athe2","text":"Notes to be included","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fhcbi","text":"Other Information","type":"header-four","depth":0,"inlineStyleRanges":[{"offset":0,"length":17,"style":"color-rgb(52,58,64)"},{"offset":0,"length":17,"style":"fontsize-1.35rem"},{"offset":0,"length":17,"style":"fontfamily-Inter, sans-serif"}],"entityRanges":[],"data":{"text-align":"start"}},{"key":"8a2l3","text":"Other relevant information","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":26,"style":"color-rgb(80,93,105)"},{"offset":0,"length":26,"style":"fontsize-14.4"},{"offset":0,"length":26,"style":"fontfamily-Nunito, sans-serif"}],"entityRanges":[],"data":{"text-align":"start"}}],"entityMap":{}};

        this.setState({  
            editorState: EditorState.createWithContent(convertFromRaw(defaultContent)),
            id: 0
          }); 
    }

    saveTask(event) {
        event.preventDefault();
        const convertedContent = JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent()));
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
        const accessToken = session.jwtToken;
        fetch(process.env.REACT_APP_API + 'victim/narrative/'+ this.props.victimId, { 
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                id: this.state.id,
                week: this.state.week,
                victimId: this.state.victimId,
                content: convertedContent,
                userId: userId
            }),
        })
        .then(res=>res.json())
        .then(response => {
            if(response > 0){
                console.log("added narrative report");
                this.setState({
                    success: true
                });
            }
            
        })
		.catch(error => {
			console.log(error, "error")
		})       
        event.preventDefault();
    }

    onEditorStateChange(editorState) {
        this.setState({
            editorState,
            success: false
        });

    }

    render() {
        return (
            <Col xl={12}>
                <Card>
                    <CardBody>
                        <h4 className="card-title">Testimony Narrative Report</h4>
                        <p className="card-title-desc">
                            This is incremental Narrative Report based on data gathered for a person. This text will be incorparated into pdf document.
                            Please start writing. Remember to save your changes. You may load last saved version. If you load latest version it may override your existing text, so be aware to save it before.
                        </p>

                        <Editor
                            editorState={this.state.editorState}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="editorClassName"
                            onEditorStateChange={this.onEditorStateChange}
                        />
                        <Alert color="success" isOpen={this.state.success} > Success </Alert>
                        <Button
                            type="submit"
                            color="primary"
                            onClick={this.saveTask}
                        >
                            Save Narrative Report
                        </Button>
                        <Button
                            type="submit"
                            color="secondary"
                            onClick={this.emptyTemplate}
                        >
                            Start With Empty Template
                        </Button>
                    </CardBody>
                </Card>
            </Col>

        );
    }
}

export default TestimonyReportEditor;